module.exports = __webpack_public_path__ + "img/1470990651.ab4142f9.jpg";